import React, { Fragment, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import esLocale from "date-fns/locale/es";
import { Box, Button, FormControl, Grid, Input, InputLabel, } from "@mui/material";
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Store } from 'react-notifications-component';
import Typography from "@mui/material/Typography";
import DialogContentText from "@mui/material/DialogContentText";
import { faAddressBook, faTrash } from "@fortawesome/free-solid-svg-icons";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { v4 as uuidv4 } from "uuid";
import styles from "./PanelRegistroPredio.module.css";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import { useStateIfMounted } from "use-state-if-mounted";
import { } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { obtenerCatalogoMaguey } from "../../../redux/DucksUsuarioAgricola/CatalogoMagueyDucks";
import { obtenerTodosLosClientesConDetalle, actualizarPredioCliente, registroPredioCliente, } from "../../../redux/InformacionValidaDucks";
import { obtenerUltimoRegistro, creacionDatoPredio, obtenerRegistroPrediosByIdAsociado, } from "../../../redux/DucksUsuarioAgricola/RegistroPredioDucks";
import ModalMensaje from '../ModalMensaje';
import {
  obtenerEstadosApi,
  obtenerMunicipiosConClavePorEstadoApi,
  obtenerLocalidadesPorEstadoYMunicipioApi,
  resetDataCopomex
} from "../../../redux/DucksApis/CopomexDucks";
import { WindowSharp } from "@mui/icons-material";
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import moment from 'moment'
import estilos from "./PanelRegistroPredio.module.css"
const PanelRegistroPredio = (props) => {
  const dispatch = useDispatch();

  const [modal, setModal] = React.useState(false)
  const [textoModal, setTextoModal] = React.useState('')
  const [tituloModal, setTituloModal] = React.useState('')

  const resetValores = (objectProducto) => {
    setModal(objectProducto.validacion)
  }

  const usuario = useSelector((store) => store.Usuario?.user[0]?.usuario);

  let dataAsociados = [];
  const dataEspecies = useSelector(
    (store) => store.CatalogoMagueyApi?.data?.data
  );
  dataAsociados = useSelector((store) => store.InformacionValidaApi.data.data);

  let dataEstados = [
    'Oaxaca', 'Guerrero', 'San Luis Potosí', 'Zacatecas', 'Durango',
    'Tamaulipas', 'Guanajuato', 'Michoacán de Ocampo', 'Puebla',
  ];
  //dataEstados = useSelector((store) => store.CopomexApi.estados);
  let dataMunicipio = [];
  dataMunicipio = useSelector((store) => store.CopomexApi.municipios);
  let dataLocalidades = [];
  dataLocalidades = useSelector((store) => store.CopomexApi.localidades);

  const numMaxPredio = useSelector(
    (store) => store.RegistroPredioApi.maxNumPredio.data
  );
  //const idPredio = (number, len) => "0".repeat(len - number.toString().length) + number.toString();

  const idPredio = (input, len) => {
    const number = parseInt(input, 10);
    const paddedNumber = number.toString().padStart(len, "0");
    return paddedNumber;
  };

  const [isKmlFile, setIsKmlFile] = React.useState(null);
  const [kmlFile, setKmlFile] = React.useState();
  const kmlHandler = (event) => {
    setKmlFile(event.target.files[0]);
    setIsKmlFile(true);
  };
  const [openModal, setOpenModal] = React.useState(false);
  const [check, setCheck] = React.useState(false);
  const [numAsociado, setNumAsociado] = React.useState("");
  const descriptionElementRef = React.useRef(null);
  const [asociado, setAsociado] = React.useState({
    idcliente: null,
    num_Asociado: null,
    numerosocio: null,
    prediocliente: [],
  });
  const [open, setOpen] = React.useState(false);
  const [fechaRegistro, setfechaRegistro] = React.useState(new Date());
  //const fechaHoy = React.useState(new Date());
  const fechaHoy = new Date()//moment().format('DD-MM-YYYY')


  const [dataTable, setDataTable] = React.useState([]);
  const [errorAgregar, setErrorAgregar] = useStateIfMounted(false);
  const [exito, setExito] = useStateIfMounted(false);
  const [alert, setAlert] = useStateIfMounted(false);
  const [alertError, setAlertError] = useStateIfMounted(false);
  const [warningNoPlantas, setWarningNoPlantas] = useStateIfMounted(false);
  const [warningNombrePredioRepetido, setWarningNombrePredioRepetido] =
    useStateIfMounted(false);

  const [warningRegistroPredio, setWarningRegistroPredio] =
    useStateIfMounted(false);

  const [textWarningRegistroPredio, setTextWarningRegistroPredio] =
    useStateIfMounted("");
  const [alertPredio, setAlertPredio] = useStateIfMounted(false);
  const [predioARegistrar, setPredioARegistrar] = React.useState({
    cultivado: false,
    semicultivado: false,
    silvestre: false,
    //tipoplantacion: '',
    nombreparaje: null,
    localidad: null,
    municipio: null,
    distrito: null,
    estado: null,
    idcliente: null,
  });
  const handleClickOpen = async (item) => {
    if (asociado !== null && asociado.numerosocio !== null) {
      setOpenModal(true);
      //dispatch(obtenerEstadosApi());
    }
  };
  useEffect(async () => {
    await dispatch(resetDataCopomex())
  }, []);
  const handleClose = () => {
    setOpenModal(false);
  };

  const [predio, setPredio] = React.useState({
    superficiehectarea: "",
    longitudoeste: "",
    latitudnorte: "",
    edad: 0,
    fecharegistro: null,
    estado: null,
    municipio: null,
    localidad: null,
    tenenciatierra: "",
    usufructotierra: "",
    representantecampo: "",
    espropietario: null,
    nombrecompletopropietario: null,
    idcliente: null,
    nombreusuario: "",
  });
  const [predioPreRegistro, setPredioPreRegistro] = React.useState({
    idpredio: null,
    cultivado: null,
    semicultivado: null,
    silvestre: null,
    nombreparaje: null,
    localidad: null,
    municipio: null,
    distrito: null,
    estado: null,
    idcliente: null,
    tipoplantacion: null,
  });
  const [tenencia, setTenencia] = React.useState(null);
  const [usuFruto, setUsuFruto] = React.useState(null);


  const [isUnaGuia, setIsUnaGuia] = React.useState(null);
  const [registroMaguey, setRegistroMaguey] = React.useState(null);

  const [temMaguey, setTemMaguey] = React.useState({
    iddatosmaguey: null,
    numeroplantas: null,
    idgenerarguia: null,
    sistemaplantacion: null,
    distanciaplantas: null,
    distanciasurcos: null,
    edad: null,
    idcatalogomaguey: null,
    fechacreacion: null,
  });

  const [especiaMaguey, setEspeciaMaguey] = React.useState(null);
  const [isVisibleGuardar, setIsVisibleGuardar] = React.useState(false);

  const style = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "#ddd",
    cursor: "not-allowed",
    pointerEvents: "none",
  };

  const styleNormal = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "white",
  };
  const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPredio((prevState) => ({
      ...prevState,
      [name]: value?.toUpperCase(),
    }));
  };

  const handleMagueyChange = (e) => {
    const { name, value } = e.target;
    setTemMaguey((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "numeroplantas" && !isNaN(value)) {
      if (value > 0) {
        if (predio !== null && predio.superficiehectarea !== null) {
          if (Number(value) / Number(predio.superficiehectarea) > 5000) {
            setWarningNoPlantas(true);
            setAlert(true);
          } else {
            setWarningNoPlantas(false);
            setAlert(false);
          }
        }
      }
    }
  };

  const dataTenencia = [
    { id: 1, opcion: "EJIDAL" },
    { id: 2, opcion: "COMUNAL" },
    { id: 3, opcion: "PRIVADA" },
  ];

  const dataUsufruto = [
    { id: 1, opcion: "A MEDIAS " },
    { id: 2, opcion: "RENTADO" },
    { id: 3, opcion: "PROPIEDAD" },
    { id: 4, opcion: "PRESTADO" },
  ];

  const handlerSeleccion = (value) => {
    setAsociado(value);
  };

  const agregarItemTabla = () => {
    const id = uuidv4();
    const { distanciasurcos, distanciaplantas, numeroplantas, edad } = temMaguey;

    if (temMaguey?.sistemaplantacion !== null && temMaguey?.sistemaplantacion !== undefined && temMaguey?.sistemaplantacion !== '') {
      if (temMaguey?.distanciasurcos != null || temMaguey?.distanciasurcos != '') {
        if (distanciaplantas !== null && distanciaplantas !== undefined && distanciaplantas !== '') {
          if (numeroplantas !== null && numeroplantas !== undefined && numeroplantas !== '') {
            if (edad !== null && edad !== undefined && edad !== '' && edad !== 0) {
              if (especiaMaguey != null) {
                const aux = {
                  iddatosmaguey: id,
                  sistemaplantacion: temMaguey.sistemaplantacion,
                  distanciasurcos: distanciasurcos,
                  distanciaplantas: distanciaplantas,
                  numeroplantas: numeroplantas,
                  edad: edad,
                  especie: especiaMaguey.nombrecomun,
                  especieCientifico: especiaMaguey.catalogomagueynombrecientifico.nombrecientifico,
                  idcatalogomaguey: especiaMaguey.idcatalogomaguey,
                };
                const dataAux = [...dataTable, aux];
                setRegistroMaguey(null)
                setTemMaguey({
                  iddatosmaguey: null,
                  numeroplantas: null,
                  idgenerarguia: null,
                  sistemaplantacion: "",
                  distanciaplantas: null,
                  distanciasurcos: null,
                  edad: null,
                  idcatalogomaguey: null,
                  fechacreacion: null,
                });
                setEspeciaMaguey(null)
                setDataTable(dataAux);

                Store.addNotification({
                  title: "Maguey",
                  message: "Añadido exitosamente!",
                  type: "success",
                  insert: "center",
                  container: "top-center",
                  animationIn: ["animate__animated", "animate__fadeIn"],
                  animationOut: ["animate__animated", "animate__fadeOut"],
                  dismiss: {
                    duration: 3000,
                    onScreen: true
                  }
                });


              } else {
                setTextoModal('Falta ingresar la especie')
                setTituloModal('Campos Obligatorios')
                setModal(true)
              }
            } else {
              setTextoModal('Falta ingresar la edad')
              setTituloModal('Campos Obligatorios')
              setModal(true)
            }
          } else {
            setTextoModal('Falta ingresar número de Plantas')
            setTituloModal('Campos Obligatorios')
            setModal(true)
          }
        } else {
          setTextoModal('Falta ingresar la distancia (Plantas)')
          setTituloModal('Campos Obligatorios')
          setModal(true)
        }
      } else {
        setTextoModal('Falta ingresar la distancia (Surcos)')
        setTituloModal('Campos Obligatorios')
        setModal(true)
      }
    } else {
      setTextoModal('Falta Agregar Sistema Plantación')
      setTituloModal('Campos Obligatorios')
      setModal(true)
    }
  }
  const eliminarData = (e) => {
    const aux = dataTable.filter((item) => item.iddatosmaguey !== e.toString());
    setDataTable(aux);
    setOpenModalVerificar(false)
  };

  useEffect(() => {
    if (asociado !== null && asociado.idcliente !== null) {
      setIsVisibleGuardar(false);
      setPredioARegistrar((prevState) => ({
        ...prevState,
        idcliente: asociado.idcliente,
      }));
    } else {
      setIsVisibleGuardar(true);
      resetInitInfo();
    }
  }, [asociado]);

  useEffect(() => {
    dispatch(obtenerUltimoRegistro());
    dispatch(obtenerCatalogoMaguey());
    dispatch(obtenerTodosLosClientesConDetalle());

  }, [dispatch]);

  useEffect(() => {
    dispatch(obtenerUltimoRegistro());
  }, []);

  useEffect(() => {
    if (openModal === false) {
      dispatch(obtenerUltimoRegistro());
      predioARegistrar.estado = null;
      predioARegistrar.localidad = null;
      predioARegistrar.municipio = null;
      setAlertPredio(false);
    }
  }, [openModal]);
  const handleChangePredioARegistar = (e) => {
    const { name, value } = e.target;
    setPredioARegistrar((prevState) => ({
      ...prevState,
      [name]: value?.toUpperCase(),
    }));
  };
  const handleGuardarPredioARegistrar = async () => {
    try {
      if (asociado && asociado.idcliente !== null) {
        if (isObjetoValido(predioARegistrar) /*&& predioARegistrar.tipoplantacion!='' && predioARegistrar.tipoplantacion!=null*/) {
          if (!isPredioRepetido(predioARegistrar.nombreparaje)) {
            await dispatch(actualizarLoadingApp_true())
            setAlertPredio(false);
            const nombreParajeMayusculas = predioARegistrar?.nombreparaje?.toUpperCase()

            if (predioARegistrar.tipoplantacion == "CULTIVADO") predioARegistrar.cultivado = true
            if (predioARegistrar.tipoplantacion == "SEMICULTIVADO") predioARegistrar.semicultivado = true
            if (predioARegistrar.tipoplantacion == "SILVESTRE") predioARegistrar.silvestre = true
            await delete predioARegistrar.tipoplantacion
            predioARegistrar.estado = predioARegistrar.estado?.toUpperCase()
            predioARegistrar.municipio = predioARegistrar.municipio?.toUpperCase()
            predioARegistrar.localidad = predioARegistrar.localidad?.toUpperCase()
            predioARegistrar.nombreparaje = nombreParajeMayusculas
            await dispatch(registroPredioCliente({ data: predioARegistrar }));

            let resultado = await dispatch(obtenerTodosLosClientesConDetalle());
            setOpenModal(false);
            let cliente = resultado?.payload?.data?.data?.filter(anexo => anexo.idcliente == asociado.idcliente)
            //let filtro = cliente?.[0]?.prediocliente?.filter(anexo => anexo.isendatospredio == false)
            //asociado.prediocliente = filtro
            setAsociado(cliente?.[0])
            predioARegistrar.nombreparaje = '';
            await dispatch(actualizarLoadingApp_false())
            Store.addNotification({
              title: "Predio",
              message: "Guardado exitosamente!",
              type: "success",
              insert: "center",
              container: "top-center",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 3000,
                onScreen: true
              }
            });


          } else {
            setWarningNombrePredioRepetido(true);
            setAlertPredio(true);
          }
        } else {
          setTituloModal('Campos Obligatorios')
          setTextoModal("Es necesario llenar todos los campos")
          setModal(true)
          /*setWarningRegistroPredio(true);
          setAlertPredio(true);
          setTextWarningRegistroPredio("Es necesario llenar todos los campos");*/
        }
      } else {
        setTituloModal('Campos Obligatorios')
        setTextoModal("Es necesario tener un asociado")
        setModal(true)
        /*setWarningRegistroPredio(true);
        setAlertPredio(true);
        setTextWarningRegistroPredio("Es necesario tener un asociado");*/
      }
    } catch (rejectedValueOrSerializedError) { }
  };

  const isPredioRepetido = (nombrePredio) => {
    if (
      asociado !== null &&
      asociado !== undefined &&
      asociado.prediocliente !== null
    ) {
      if (
        asociado.prediocliente.some(
          (p) =>
            p.nombreparaje.toLowerCase().trim() ===
            nombrePredio.toLowerCase().trim()
        )
      ) {
        return true;
      } else {
        false;
      }
    } else {
      return true;
    }
  };

  const isObjetoValido = (objeto) => {
    return Object.values(objeto).every((value) => {
      if (value === null || value === undefined || value === "") {
        return false;
      }
      return true;
    });
  };

  const guardarRegistro = async () => {
    let data = {
      kmlFile: kmlFile,
      idcliente: asociado.idcliente,
      numerosocio: asociado.numerosocio,
      datospredio: [
        {
          ...predio,
          fecharegistro: fechaRegistro,
          nombrepredio: predioPreRegistro?.nombreparaje?.toUpperCase(),
          estado: predioPreRegistro.estado,
          municipio: predioPreRegistro.municipio,
          localidad: predioPreRegistro.localidad,
          espropietario: check,
          nombrecompletopropietario:
            check === true ? predio?.nombrecompletopropietario?.toUpperCase() : "",
          tenenciatierra: tenencia.opcion,
          usufructotierra: usuFruto.opcion,
          edad: 0,
          idcliente: asociado.idcliente,
          nombreusuario: usuario ? usuario : "",
        },
      ],
      datosmaguey: dataTable.map((d) => {
        return d;
      }),
      tipoGuia: isUnaGuia.op,
    };
    if (
      data.datospredio[0].latitudnorte === "" ||
      data.datospredio[0].longitudoeste === "" ||
      data.datospredio[0].superficiehectarea === ""
    ) {
      return false;
    } else {
      let resultado = await dispatch(creacionDatoPredio({ data: data }));
      return resultado
    }
  };
  const verificarInformacion = async () => {
    let verificar = false
    if (predioPreRegistro.nombreparaje != null && predioPreRegistro.nombreparaje != undefined && predioPreRegistro.nombreparaje != '') {
      if (tenencia?.opcion != null && tenencia?.opcion != undefined && tenencia?.opcion != '') {
        if (usuFruto?.opcion != null && usuFruto?.opcion != undefined && usuFruto?.opcion != '') {
          if (predio?.latitudnorte != null && predio?.latitudnorte != undefined && predio?.latitudnorte != '') {
            if (predio?.longitudoeste != null && predio?.longitudoeste != undefined && predio?.longitudoeste != '') {
              if (predio?.superficiehectarea != null && predio?.superficiehectarea != undefined && predio?.superficiehectarea != '') {
                if (predio?.representantecampo != null && predio?.representantecampo != undefined && predio?.representantecampo != '') {
                  if (isUnaGuia?.op != null && isUnaGuia?.op != undefined && isUnaGuia?.op != '') {
                    if (dataTable.length > 0) {
                      if ((isUnaGuia?.op == "NORMAL" && isKmlFile != null && isKmlFile != false) || isUnaGuia?.op == 'EXTEMPORÁNEO') {
                        verificar = true
                      } else {
                        setTextoModal('Falta ingresar el archivo en KML')
                        setTituloModal('Campos Obligatorios')
                        setModal(true)
                        setOpenModalVerificar(false)

                      }
                    } else {
                      setTextoModal('Falta ingresar datos del maguey')
                      setTituloModal('Campos Obligatorios')
                      setModal(true)
                      setOpenModalVerificar(false)
                    }
                  } else {
                    setTextoModal('Falta ingresar el tipo de registro')
                    setTituloModal('Campos Obligatorios')
                    setModal(true)
                    setOpenModalVerificar(false)
                  }
                } else {
                  setTextoModal('Falta ingresar el representante de campo')
                  setTituloModal('Campos Obligatorios')
                  setModal(true)
                  setOpenModalVerificar(false)
                }
              } else {
                setTextoModal('Falta ingresar la superficie (Hectareas)')
                setTituloModal('Campos Obligatorios')
                setModal(true)
                setOpenModalVerificar(false)
              }
            } else {
              setTextoModal('Falta ingresar la longitud')
              setTituloModal('Campos Obligatorios')
              setModal(true)
              setOpenModalVerificar(false)
            }
          } else {
            setTextoModal('Falta ingresar la latitud')
            setTituloModal('Campos Obligatorios')
            setModal(true)
            setOpenModalVerificar(false)
          }
        } else {
          setTextoModal('Falta ingresar el usufructo')
          setTituloModal('Campos Obligatorios')
          setModal(true)
          setOpenModalVerificar(false)
        }
      } else {
        setTextoModal('Falta ingresar la tenencia')
        setTituloModal('Campos Obligatorios')
        setModal(true)
        setOpenModalVerificar(false)
      }

    } else {
      setTextoModal('Falta ingresar el nombre del paraje')
      setTituloModal('Campos Obligatorios')
      setModal(true)
      setOpenModalVerificar(false)
    }
    return verificar
  }
  const enviarInfo = async () => {
    if (await verificarInformacion()) {
      try {

        await dispatch(actualizarLoadingApp_true())

        const respuesta = await guardarRegistro();

        await dispatch(actualizarPredioCliente({ data: { ...predioPreRegistro, isendatospredio: true }, }));
        setOpenModalVerificar(false)
        await dispatch(actualizarLoadingApp_false())

        if (!respuesta) {
          setAlertError(true);
        } else {
          setExito(true);
          await dispatch(obtenerTodosLosClientesConDetalle());
          resetInitInfo();
          window.location.reload(true);
        }

      } catch (rejectedValueOrSerializedError) {
        setErrorAgregar(true);
      }
      setAlert(true);
    }

  };

  const resetInitInfo = () => {
    setPredio({
      superficiehectarea: "",
      longitudoeste: "",
      latitudnorte: "",
      edad: 0,
      fecharegistro: null,
      estado: null,
      municipio: null,
      localidad: null,
      tenenciatierra: "",
      usufructotierra: "",
      representantecampo: "",
      espropietario: null,
      nombrecompletopropietario: null,
      idcliente: null,
      nombreusuario: "",
    });
    setTemMaguey({
      iddatosmaguey: null,
      numeroplantas: null,
      idgenerarguia: null,
      sistemaplantacion: null,
      distanciaplantas: null,
      distanciasurcos: null,
      edad: null,
      idcatalogomaguey: null,
      fechacreacion: null,
    });

    setDataTable([]);
    setIsUnaGuia(null);
    setUsuFruto(null);
    setEspeciaMaguey(null);
    setTenencia(null);
    setRegistroMaguey(null);
  };

  const body = (
    <>

    </>
  );

  const validarLatitud = (latitud) => {
    let latituRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let latitudRegex = /^(\-?([0-8]?[0-9](\.\d+)?|90(.[0]+)?)\s?[°]\s?)/;
    let a = ''
    if (!latitud) return false
    if (latitud.match(latitudRegex)) {
      return false
    } else {
      return true
    }

  }








  const [openModalVerificar, setOpenModalVerificar] = React.useState(false);
  const [titleModal, setTitleModal] = React.useState('');
  const [bodyModal, setBodyModal] = React.useState('')
  const [accion, setAccion] = React.useState('')
  const [dataModal, setDataModal] = React.useState('')

  const handleOpenModal = (data) => {
    setTitleModal(data.title)
    setBodyModal(data.body)
    setAccion(data.accion)
    setOpenModalVerificar(true)
    setDataModal(data.data)
  }
  const handleCloseModal = () => {
    setTitleModal('')
    setBodyModal('')
    setAccion('')
    setOpenModalVerificar(false)
    setDataModal('')
  }
  const modalComponent = () => {
    return (
      <div>
        <Modal open={openModalVerificar} onClose={handleCloseModal}
          aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
          <Box sx={styleModal}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <center className="text-danger">{titleModal}</center>
            </Typography>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
              <p >{bodyModal}</p> <br /> <center><strong>¿Desea continuar?</strong></center>
            </Typography>
            <br />
            <div className='row'>
              <div className="col-5">
                <button className='btn btn-success' onClick={() => {
                  switch (accion) {
                    case 'eliminarDeTabla':
                      eliminarData(idEliminar)
                      break;
                    case 'guardarDatosPredio':
                      enviarInfo()
                      Store.addNotification({
                        title: "Datos completos del Predio",
                        message: "Guardado exitosamente!",
                        type: "success",
                        insert: "center",
                        container: "top-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 3000,
                          onScreen: true
                        }
                      });
                      break;
                    default:
                      break;
                  }
                }}>CONTINUAR</button>
              </div> <div className="col-2"></div>
              <div className="col-5">
                <button className='btn btn-dark' onClick={() => handleCloseModal()} >CANCELAR</button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    )
  }
  const [idEliminar, setIdEliminar] = React.useState('')
  const botonEliminar = async (params) => {
    handleOpenModal({
      title: `¡Advertencia!`,
      body: `Está a seguro que desea eliminar los datos de este maguey?.`,
      accion: 'eliminarDeTabla'
    })
    setIdEliminar(params)
  }
  const botonGuardar = async (params) => {
    handleOpenModal({
      title: `¡Advertencia!`,
      body: `Está a seguro que desea guardar los datos registrados del predio?.`,
      accion: 'guardarDatosPredio'
    })
  }

  return (
    <Fragment>
      <br />
      <div className="container">
        <h2 className="text-center">Registro de Predio</h2> <br />
        <div className="bg-light p-5 rounded ms-5">
          <div className="row">
            <div className="col-12">
              <h4 className={`${estilos.labelEspecial} text-center pt-3`}>Datos del Productor</h4><hr />
              <div className="pt-2">
                <div className="row g-3">
                  <div className="col-sm-2">
                    <label className="form-label">
                      <b>No. Predio "A":</b>
                    </label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={idPredio(numMaxPredio + 1, 5)}
                    />
                  </div>

                  <div className="col-sm-2">
                    <label className="form-label">
                      <b>No. Cliente:</b>
                    </label>

                    <Autocomplete
                      freeSolo
                      open={open}
                      onOpen={() => {
                        if (numAsociado) {
                          setOpen(true);
                        }
                      }}
                      onClose={() => setOpen(false)}
                      inputValue={numAsociado ? numAsociado : ""}
                      onInputChange={(e, value) => {
                        setNumAsociado(value);

                        if (!value) {
                          setOpen(false);
                        }
                      }}
                      onChange={(event, value = "") => {
                        handlerSeleccion(value);
                      }}
                      options={dataAsociados ? dataAsociados : []}
                      getOptionLabel={(opcion) =>
                        opcion ? opcion.numerosocio + "" : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                          fullWidth
                          onKeyDown={(e) => {
                           !open && e.key === "Enter" && e.stopPropagation();
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-sm-8">
                    <label className="form-label">
                      <b>Nombre Cliente:</b>
                    </label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      value={
                        asociado !== null && asociado.nombrerazonsocial !== null
                          ? asociado?.nombrerazonsocial?.toUpperCase()
                          : ""
                      }
                    />
                  </div>
                  <hr />
                  {numAsociado.length == 4 &&
                    <Fragment>
                      <div className="col-12">
                        <div className="row">
                          <div className="d-flex justify-content-start">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    className="btn btn-primary"
                                    checked={openModal}
                                    onChange={(e) => {
                                      openModal === true
                                        ? handleClose()
                                        : handleClickOpen();
                                    }}
                                    name="nuevoPredio"
                                  />
                                }
                                label="Agregar Predio"
                              />
                            </FormGroup>
                          </div>
                          {openModal ? (
                            <div className="col-12">
                              <div className="bg-light rounded  ">
                                {warningNombrePredioRepetido && alertPredio && (
                                  <Stack sx={{ width: "100%" }} spacing={2}>
                                    <Alert
                                      severity="warning"
                                      onClose={() => {
                                        setAlertPredio(false);
                                      }}
                                    >
                                      El nombre del predio ya se encuentra
                                      registrado.
                                    </Alert>
                                  </Stack>
                                )}

                                {warningRegistroPredio && alertPredio && (
                                  <Stack sx={{ width: "100%" }} spacing={2}>
                                    <Alert
                                      severity="warning"
                                      onClose={() => {
                                        setAlertPredio(false);
                                      }}
                                    >
                                      {textWarningRegistroPredio}
                                    </Alert>
                                  </Stack>
                                )}
                                <h4 className={`${estilos.labelEspecial} text-center pt-3`}>Agregar Predio</h4><hr />
                                <div className="row">
                                  <div className="col-6">
                                    <label className="form-label">
                                      Número de Cliente:{" "}
                                    </label>
                                    <TextField
                                      variant="outlined"
                                      disabled
                                      sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                      }}
                                      size="small"
                                      style={{ background: "white" }}
                                      fullWidth
                                      value={
                                        asociado !== null &&
                                          asociado.numerosocio !== null
                                          ? asociado.numerosocio
                                          : ""
                                      }
                                    />
                                  </div>
                                  <div className="col-6">
                                    <label className="form-label">
                                      Nombre Predio
                                    </label>
                                    <TextField
                                      variant="outlined"
                                      sx={{
                                        "& legend": { display: "none" },
                                        "& fieldset": { top: 0 },
                                      }}
                                      size="small"
                                      style={{ background: "white" }}
                                      fullWidth
                                      name="nombreparaje"
                                      value={
                                        predioARegistrar !== null &&
                                          predioARegistrar.nombreparaje !== null
                                          ? predioARegistrar.nombreparaje
                                          : ""
                                      }
                                      onChange={handleChangePredioARegistar}
                                    />
                                  </div>
                                  <div className="col-6">
                                    <label className="form-label">Estado:</label>
                                    <Autocomplete
                                      fullWidth
                                      disablePortal
                                      onChange={(event, value) => {
                                       
                                        if (value !== null) {
                                          setPredioARegistrar((prevState) => ({
                                            ...prevState,
                                            estado: value !== null ? value : "",
                                            municipio: "",
                                            localidad: "",
                                          }));
                                          dispatch(obtenerMunicipiosConClavePorEstadoApi(value));
                                        } else {
                                          setPredioARegistrar((prevState) => ({
                                            ...prevState,
                                            estado: "",
                                            municipio: "",
                                            localidad: "",
                                          }));
                                        }
                                      }}
                                      options={dataEstados ? dataEstados : []}
                                      getOptionLabel={(option) =>
                                        typeof option === "string" ||
                                          option instanceof String
                                          ? option
                                          : ""
                                      }
                                      sx={styleNormal}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            background: "white",
                                          }}
                                          size="small"
                                        />
                                      )}
                                    />
                                  </div>

                                  <div className="col-6">
                                    <label className="form-label">Municipio:</label>
                                    <Autocomplete
                                      fullWidth
                                      disablePortal
                                      onChange={(event, value) => {
                                        if (value !== null) {
                                          setPredioARegistrar((prevState) => ({
                                            ...prevState,
                                            municipio: value.municipio,
                                            distrito: value.municipio,
                                            localidad: "",
                                          }));

                                          if (
                                            predioARegistrar !== null && predioARegistrar.estado !== null &&
                                            predioARegistrar.estado !== "" && value.municipio !== null &&
                                            value.municipio !== "") {
                                            dispatch(obtenerLocalidadesPorEstadoYMunicipioApi(
                                              {
                                                estado: predioARegistrar.estado, municipio:
                                                  value !== null ? value.municipio : "",
                                              }
                                            )
                                            );
                                          }
                                        } else {
                                          setPredioARegistrar((prevState) => ({
                                            ...prevState,
                                            municipio: "",
                                            localidad: "",
                                          }));
                                        }
                                      }}
                                      options={
                                        dataMunicipio &&
                                          Object.keys(dataMunicipio).length !== 0
                                          ? dataMunicipio
                                          : []
                                      }
                                      sx={styleNormal}
                                      getOptionLabel={(option) =>
                                        option.municipio ? option.municipio : ""
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            background: "white",
                                          }}
                                          size="small"
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className="col-6">
                                    <label className="form-label">Localidad</label>
                                    <Autocomplete
                                      fullWidth
                                      disablePortal
                                      onChange={(event, value) => {
                                        if (value !== null) {
                                          setPredioARegistrar((prevState) => ({
                                            ...prevState,
                                            localidad: value.localidad,
                                          }));
                                        } else {
                                          setPredioARegistrar((prevState) => ({
                                            ...prevState,
                                            localidad: "",
                                          }));
                                        }
                                      }}
                                      options={
                                        dataLocalidades &&
                                          Object.keys(dataLocalidades).length !== 0
                                          ? dataLocalidades
                                          : []
                                      }
                                      getOptionLabel={(option) =>
                                        option !== null && option !== undefined
                                          ? option.localidad
                                          : ""
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                      }
                                      sx={styleNormal}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            background: "white",
                                          }}
                                          size="small"
                                        />
                                      )}
                                    />
                                  </div>
                                  {/*<div className="col-6">
                                    <label className="form-label">Sistema de Plantación:</label>
                                    <select className={`form-select form-select-sm`} style={{ height: '60%' }}
                                      name="tipoplantacion"
                                      value={predioARegistrar?.tipoplantacion} onChange={handleChangePredioARegistar}   >
                                      <option value="">Seleccione una opción</option>
                                      <option value="CULTIVADO">CULTIVADO</option>
                                      <option value="SEMICULTIVADO">SEMICULTIVADO</option>
                                      <option value="SILVESTRE">SILVESTRE</option>
                                    </select>
                                  </div>*/}
                                  <div className="d-flex justify-content-center pt-4">
                                    <Button color={"success"} variant="contained" onClick={handleGuardarPredioARegistrar} > Guardar Predio </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                        <hr /><br />
                        <h4 className={`${estilos.labelEspecial} text-center pt-3`}>Datos del Predio</h4>

                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="secondary"
                                checked={check}
                                onChange={(e) => {
                                  setCheck(!check);
                                }}
                                name="Propietario"
                              />
                            }
                            label="Agregar Propietario"
                          />
                        </FormGroup>
                        <hr />
                        {check ? (
                          <div>
                            <label className="form-label">Nombre completo</label>
                            <TextField
                              fullWidth
                              sx={styleNormal}
                              size="small"
                              value={predio?.nombrecompletopropietario?.toUpperCase()}
                              name="nombrecompletopropietario"
                              onChange={handleChange}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>

                      <div className="col-6">
                        <label className="form-label">Fecha de registro:</label>
                        <br />
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          locale={esLocale}
                        >
                          <DatePicker
                            value={fechaRegistro}
                            maxDate={fechaHoy}
                            fullWidth
                            onChange={(newValue) => {
                              setfechaRegistro(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                sx={styleNormal}
                                size="small"
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="col-6">
                        <label className="form-label">Nombre del predio:</label>
                        <Autocomplete
                          fullWidth
                          disablePortal
                          inputValue={
                            asociado !== null &&
                              predioPreRegistro &&
                              predioPreRegistro.nombreparaje
                              ? predioPreRegistro.nombreparaje
                              : ""
                          }
                          options={
                            asociado !== null &&
                              asociado.prediocliente !== null &&
                              asociado.prediocliente !== undefined
                              ? asociado.prediocliente.filter(
                                (item) => item.isendatospredio === false
                              )
                              : []
                          }
                          getOptionLabel={(opcion) => opcion.nombreparaje}
                          onChange={(event, value) => {
                            setPredioPreRegistro(value);
                          }}
                          sx={styleNormal}
                          isOptionEqualToValue={(option, value) =>
                            option.idpredio === value.idpredio
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                background: "white",
                              }}
                              size="small"
                            />
                          )}
                        />
                      </div>

                      <div className="col-4">
                        <label className="form-label">Estado:</label>
                        <TextField
                          disabled
                          fullWidth
                          sx={style}
                          size="small"
                          name="estado"
                          onChange={handleChange}
                          value={
                            asociado !== null &&
                              predioPreRegistro &&
                              predioPreRegistro.estado !== null
                              ? predioPreRegistro.estado
                              : ""
                          }
                        />
                      </div>
                      <div className="col-4">
                        <label className="form-label">Municipio:</label>
                        <TextField
                          disabled
                          fullWidth
                          sx={style}
                          size="small"
                          name="municipio"
                          onChange={handleChange}
                          value={
                            asociado !== null &&
                              predioPreRegistro &&
                              predioPreRegistro.municipio !== null
                              ? predioPreRegistro.municipio
                              : ""
                          }
                        />
                      </div>
                      <div className="col-4">
                        <label className="form-label">Localidad:</label>
                        <TextField
                          disabled
                          fullWidth
                          sx={style}
                          size="small"
                          name="localidad"
                          onChange={handleChange}
                          value={
                            asociado !== null &&
                              predioPreRegistro &&
                              predioPreRegistro.localidad !== null
                              ? predioPreRegistro.localidad
                              : ""
                          }
                        />
                      </div>

                      <div className="col-6">
                        <label className="form-label">Tenencia de la Tierra:</label>
                        <Autocomplete
                          inputValue={asociado !== null && tenencia !== null ? tenencia.opcion : ""}
                          fullWidth
                          disablePortal
                          onChange={(event, value) => {
                            setTenencia(value);
                          }}
                          options={dataTenencia}
                          disabled={asociado !== null ? false : true}
                          sx={styleNormal}
                          getOptionLabel={(opcion) => opcion.opcion || ""}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                background: "white",
                              }}
                              size="small"
                            />
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <label className="form-label">Usufructo de la Tierra:</label>
                        <Autocomplete
                          inputValue={
                            asociado !== null && usuFruto !== null
                              ? usuFruto.opcion
                              : ""
                          }
                          disabled={asociado !== null ? false : true}
                          fullWidth
                          disablePortal
                          onChange={(event, value) => {
                            setUsuFruto(value);
                          }}
                          options={dataUsufruto}
                          sx={styleNormal}
                          getOptionLabel={(opcion) => opcion.opcion || ""}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                background: "white",
                              }}
                              size="small"
                            />
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <label className="form-label">Latitud Norte:</label>
                        <TextField
                          fullWidth
                          //error = {validarLatitud(predio?.latitudnorte)}
                          disabled={asociado !== null ? false : true}
                          sx={asociado !== null ? styleNormal : style}
                          type="text"
                          size="small"
                          name="latitudnorte"
                          onChange={e => predio?.latitudnorte.length <= 10 ? handleChange(e) : ''}
                          value={
                            predio !== null && predio.latitudnorte !== null
                              ? predio.latitudnorte
                              : ""
                          }
                        />
                      </div>
                      <div className="col-6">
                        <label className="form-label">Longitud Oeste:</label>
                        <TextField
                          fullWidth
                          disabled={asociado !== null ? false : true}
                          sx={asociado !== null ? styleNormal : style}
                          type="text"
                          size="small"
                          //defaultValue={""}
                          name="longitudoeste"
                          onChange={e => predio?.longitudoeste.length < 10 ? handleChange(e) : ''}
                          value={
                            predio !== null && predio.longitudoeste !== null
                              ? predio.longitudoeste
                              : ""
                          }
                        />
                      </div>

                      <div className="col-6">
                        <label className="form-label">
                          Superficie (Hectáreas):
                        </label>
                        <TextField
                          fullWidth
                          disabled={asociado !== null ? false : true}
                          sx={asociado !== null ? styleNormal : style}
                          type="number"
                          inputProps={{
                            inputMode: "numeric",
                            min: 1,
                          }}
                          size="small"
                          name="superficiehectarea"
                          onChange={handleChange}
                        />
                      </div>

                      <div className="col-6">
                        <label className="form-label">
                          Representante de Campo:
                        </label>
                        <TextField
                          fullWidth
                          disabled={asociado !== null ? false : true}
                          sx={asociado !== null ? styleNormal : style}
                          type="text"
                          size="small"
                          //defaultValue={""}
                          name="representantecampo"
                          onChange={handleChange}
                          value={
                            predio !== null &&
                              predio.representantecampo !== null &&
                              predio.representantecampo !== ""
                              ? predio.representantecampo
                              : ""
                          }
                        />
                      </div>
                      <div className="col-sm-6">
                        <label className="form-label">Tipo de Registro:</label>
                        <Autocomplete
                          disabled={asociado !== null ? false : true}
                          fullWidth
                          disablePortal
                          options={[
                            { id: 0, op: "NORMAL" },
                            { id: 1, op: "EXTEMPORÁNEO" },
                          ]}
                          getOptionLabel={(opcion) => opcion.op} onChange={(event, value) => { setIsUnaGuia(value); }}
                          sx={styleNormal} isOptionEqualToValue={(option, value) => option.id === value.id}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, background: "white", }}
                              size="small"
                            />
                          )}
                        />
                      </div>
                      {isUnaGuia?.id == 0 && isUnaGuia != null &&
                        <div className="col-6 text-center ">
                          <Stack direction="row" className="text-center">
                            <label className="form-label mt-4 me-5">Subir Polígono: </label>
                            <label htmlFor="contained-button-file" style={{ width: 100 }}>
                              <input accept=".kml,.KML" id="contained-button-file" type="file" disabled={asociado !== null ? false : true} style={{ display: "none" }} onChange={kmlHandler} />
                              <Button variant="contained" fullWidth component="span" className="mt-3" disabled={asociado !== null ? false : true} color='primary' >
                                <FileUploadIcon />
                                Cargar KML </Button>
                            </label>
                          </Stack>
                          {isKmlFile ? (
                            <p>Filename: {kmlFile.name}</p>
                          ) : (
                            ''
                          )}
                        </div>
                      }
                      <hr />
                      <h4 className={`${estilos.labelEspecial} text-center pt-3`}> Datos del Maguey</h4>
                      <div className="pt-3">
                        <div className="row g-4 justify-content-between ">

                          <div className="col-4">
                            <label className="form-label">
                              Sistema de plantación:
                            </label>
                            <select className={`form-select form-select-sm`} style={{ height: '60%' }}
                              name="sistemaplantacion"
                              value={temMaguey?.sistemaplantacion} onChange={handleMagueyChange}   >
                              <option value="">SELECCIONE UNA OPCIÓN</option>
                              <option value="CULTIVADO">CULTIVADO</option>
                              <option value="SEMICULTIVADO">SEMICULTIVADO</option>
                              <option value="SILVESTRE">SILVESTRE</option>
                            </select>
                            {/*<Autocomplete fullWidth disabled={asociado !== null ? false : true} disablePortal
                              options={[
                                { id: 1, op: "CULTIVADO" },
                                { id: 2, op: "SEMICULTIVADO" },
                                { id: 3, op: "SILVESTRE" },
                              ]}
                              name="sistemaplantacion"
                              getOptionLabel={(opcion) => opcion.op}
                              onChange={(event, value) => { setRegistroMaguey(value); }}

                              sx={styleNormal}
                              value={temMaguey?.sistemaplantacion != null ? temMaguey?.sistemaplantacion : null}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    background: "white",
                                  }} size="small" />
                              )}
                                />*/}
                          </div>
                          <div className="col-4">
                            <label className="form-label">Distancia (Surcos):</label>
                            <TextField
                              fullWidth
                              disabled={asociado !== null ? false : true}
                              sx={asociado !== null ? styleNormal : style}
                              type="number"
                              value={temMaguey?.distanciasurcos != null ? temMaguey?.distanciasurcos : ''}
                              inputProps={{
                                inputMode: "numeric",
                                min: 0,
                              }}
                              size="small"
                              //defaultValue={""}
                              name="distanciasurcos"
                              onChange={handleMagueyChange}
                            />
                          </div>
                          <div className="col-4">
                            <label className="form-label">Distancia (Plantas):</label>
                            <TextField
                              fullWidth
                              disabled={asociado !== null ? false : true}
                              sx={asociado !== null ? styleNormal : style}
                              type="number"
                              value={temMaguey?.distanciaplantas != null ? temMaguey?.distanciaplantas : ''}
                              inputProps={{
                                inputMode: "numeric",
                                min: 0,
                              }}
                              size="small"
                              //defaultValue={""}
                              name="distanciaplantas"
                              onChange={handleMagueyChange}
                            />
                          </div>
                          <div className="col-4">
                            <label className="form-label">Especie: </label>
                            <Autocomplete
                              inputValue={
                                asociado !== null && especiaMaguey !== null
                                  ? `${especiaMaguey.catalogomagueynombrecientifico.nombrecientifico}-${especiaMaguey.nombrecomun}`
                                  : ""
                              }
                              value={especiaMaguey?.catalogomagueynombrecientifico?.nombrecientifico + '-' + especiaMaguey?.nombrecomun}
                              fullWidth
                              disabled={asociado !== null ? false : true}
                              disablePortal
                              options={dataEspecies.filter(
                                (item) => item.activo == 1
                              )}
                              clearOnBlur={true}
                              getOptionLabel={(opcion) =>
                                `${opcion.catalogomagueynombrecientifico?.nombrecientifico}-${opcion.nombrecomun}`
                              }
                              onChange={(event, value) => {
                                setEspeciaMaguey(value);
                              }}
                              sx={styleNormal}
                              isOptionEqualToValue={(option, value) =>
                                option.idcatalogomaguey === value.idcatalogomaguey
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    background: "white",
                                  }}
                                  size="small"

                                />
                              )}
                            />
                          </div>
                          <div className="col-4">
                            <label className="form-label">No. de Plantas:</label>
                            <TextField
                              fullWidth
                              disabled={asociado !== null ? false : true}
                              sx={asociado !== null ? styleNormal : style}
                              type="number"
                              value={temMaguey?.numeroplantas != null ? temMaguey?.numeroplantas : ''}
                              inputProps={{
                                inputMode: "numeric",
                                min: 1,
                              }}
                              size="small"
                              name="numeroplantas"
                              onChange={handleMagueyChange}
                            />
                          </div>
                          <div className="col-4">
                            <label className="form-label">Edad (Años):</label>
                            <TextField
                              fullWidth
                              disabled={asociado !== null ? false : true}
                              sx={asociado !== null ? styleNormal : style}
                              type="number"
                              value={temMaguey?.edad != null ? temMaguey?.edad : ''}
                              inputProps={{
                                inputMode: "numeric",
                                min: 0,
                              }}
                              size="small"
                              name="edad"
                              onChange={handleMagueyChange}
                            />
                          </div>


                          {exito && alert && (
                            <Stack sx={{ width: "100%" }} spacing={4}>
                              <Alert
                                onClose={() => {
                                  setAlert(false);
                                  props.history.push("/PanelRegistroPredio");
                                  // window.location.reload(true);
                                }}
                              >
                                Registro agregado correctamente con No. Predio "A":{" "}
                                {numMaxPredio !== null ? numMaxPredio + 1 : ""}{" "}
                              </Alert>
                            </Stack>
                          )}
                          {errorAgregar && alert && (
                            <Stack sx={{ width: "100%" }} spacing={2}>
                              <Alert
                                severity="error"
                                onClose={() => {
                                  setAlert(false);
                                  props.history.push("/PanelRegistroPredio");
                                }}
                              >
                                Ocurrió un problema al realizar el registro.
                              </Alert>
                            </Stack>
                          )}
                          {warningNoPlantas && alert && isUnaGuia != null && isUnaGuia?.op != "EXTEMPORÁNEO" && (
                            <Stack sx={{ width: "100%" }} spacing={2}>
                              <Alert
                                severity="warning"
                                onClose={() => {
                                  setAlert(false);
                                }}
                              >
                                El Número de plantas no concuerda con el Num normal
                                para la superficie registrada
                              </Alert>
                            </Stack>
                          )}

                        </div>
                        <div className="row text-center mt-3">
                          <div className="col-4"> </div>
                          <div className="col-4">
                            <Button disabled={isVisibleGuardar} fullWidth variant="contained" onClick={agregarItemTabla} color="success" > Agregar Maguey </Button>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 pt-4">
                        <Paper sx={{ width: "100%" }}>
                          <TableContainer sx={{ maxHeight: 600 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Sistema Platación</TableCell>
                                  <TableCell>Distancia (Surcos) </TableCell>
                                  <TableCell>Distancia (Plantas)</TableCell>
                                  <TableCell>Especie</TableCell>
                                  <TableCell>No. de Plantas</TableCell>
                                  <TableCell>Edad</TableCell>
                                  <TableCell>Opciones</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {asociado !== null &&
                                  dataTable.map((item, i) => (
                                    <TableRow
                                      key={item.iddatosmaguey}
                                      sx={{
                                        "&:last-child td, &:last-child th": { border: 0 },
                                      }}
                                    >
                                      <TableCell>{item.sistemaplantacion}</TableCell>
                                      <TableCell>{item.distanciasurcos}</TableCell>
                                      <TableCell>{item.distanciaplantas}</TableCell>
                                      <TableCell>{item.especie}</TableCell>
                                      <TableCell>{item.numeroplantas}</TableCell>
                                      <TableCell>{item.edad}</TableCell>

                                      <TableCell>
                                        <button className="badge btn-warning text-dark btn-block" onClick={() => botonEliminar(item.iddatosmaguey)} >
                                          <FontAwesomeIcon icon={faTrash} /> <br /> Eliminar </button>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                        <div className="pt-2 texte-center ">
                          {alertError ? (
                            <Alert severity="error">Verifique los campos </Alert>
                          ) : (
                            ""
                          )}
                          <div className="row text-center">
                            <div className="col-4"> </div>
                            <div className="col-4">
                              <Button variant="contained" fullWidth disabled={asociado !== null && dataTable.length > 0 ? false : true} onClick={() => botonGuardar()} >  Guardar </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  }



                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      {modal && <ModalMensaje texto={textoModal} titulo={tituloModal} api={{ resetValores }}></ModalMensaje>}
      {modalComponent()}
    </Fragment>
  );
};
export default withRouter(PanelRegistroPredio);
